export default __webpack_public_path__ + "styles/main.6e44b9fc0c0620149594ecb878ab5679.css";